// extracted by mini-css-extract-plugin
module.exports = {"cardsCarousel":"CardsCarousel-module--cardsCarousel--OAGiN","removeAboveMargin":"CardsCarousel-module--removeAboveMargin--2ljsC"};